module.exports = __webpack_public_path__ + "static/media/xml.813baa1e.svg";